import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import type { ChatMessage } from '@ztechapps/common.contract'
import { gql } from '@apollo/client'
import { chatMessagesFragment } from './graphql'

export const getRecentChatMessageQuery = gql`
  ${chatMessagesFragment}
  query getRecentChatMessages($filter: GetRecentChatMessagesArgs!) {
    getRecentChatMessages(filter: $filter) {
      ...chatMessagesFragmet
    }
  }
`

export const useRecentChatMessageList = ({ query, ...rest } = {} as UseListProps): UseListResult<ChatMessage> => {
  query ??= getRecentChatMessageQuery

  return useList<ChatMessage>({ query, ...rest })
}
